export const STARTING_HAND_MODE = 'STARTING_HAND_MODE';
export const BOARD_MODE = 'BOARD_MODE';